// extracted by mini-css-extract-plugin
module.exports = {"FormLoader":"style_FormLoader__25bHm"};